import gql from 'graphql-tag';

export const getFeedbackFormDetails = () =>{

    const FEEDBACK_DETAILS =  gql`
    query  {
      wosSurveyUrls(
        first: 1,
        orderBy: publishedAt_DESC){
        id
        surveyUrl
        message
        }
  }
  `
   
    return FEEDBACK_DETAILS;  
   }

   export const getFeedbackFormDetailsPreprod = () =>{

    const FEEDBACK_DETAILS =  gql`
    query  {
        wosSurveyUrlPreprods(
        first: 1,
        orderBy: publishedAt_DESC){
        id
        surveyUrl
        message
        }
  }
  `
   
    return FEEDBACK_DETAILS;  
   }